import React from 'react';
import PropTypes from 'prop-types';
import Intro from './Views/Intro';
import BackupCode from './Views/BackupCode';
import EnterVerificationCode from './Views/EnterVerificationCode';
import CaptureQRCode from './Views/CaptureQRCode';

export const stepMap = {
  intro: { name: 'intro', component: Intro },
  captureQRCode: { name: 'captureQRCode', component: CaptureQRCode },
  backupCode: { name: 'backupCode', component: BackupCode },
  enterVerificationCode: { name: 'enterVerificationCode', component: EnterVerificationCode },
};

const Layout = ({ onSuccess }) => {
  const [stepName, setStepName] = React.useState(stepMap.intro.name);
  const Component = stepMap[stepName].component;
  const changeState = (step) => {
    const { name } = step;
    if (stepMap[name]) {
      setStepName(name);
    } else {
      throw new Error(`Invalid state name: ${name}. Must be one of:${Object.keys(stepMap)}`);
    }
  };

  return (
    <Component
      changeState={changeState}
      onSuccess={onSuccess}
    />
  );
};

Layout.propTypes = {
  onSuccess: PropTypes.func.isRequired,
};

export default Layout;
